<template>
  <v-card height="800px">
    <v-card-title>
      <span class="headline">Gérer Photos</span>
    </v-card-title>
    <v-card-subtitle>
      <p style="word-break: keep-all">
        <span style="color: #757575"
          >{{ getPollenFamille }}
          >
          {{ getPollenGenre }}
          >
        </span>
        {{ activePollen.espece }}
      </p>
    </v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text>
      <v-container>
        <v-col>
          <v-row>
            <v-col lg="8">
              <v-data-table
                :headers="headers"
                :items="
                  getImages.filter(
                    (img) =>
                      img.id_pollen ===
                      getPollensAll[getAdminActivePollenIndex].id_pollen
                  )
                "
                ><template v-slot:item.image="{ item }">
                  <div class="p-2">
                    <v-img
                      :src="item.chem_ima"
                      :alt="item.chem_ima"
                      target="_blank"
                      rel="noopener noreferrer"
                      :href="item.chem_ima"
                      max-width="100px"
                      height="100px"
                      contain
                    ></v-img>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        @click="deleteItem(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Supprimer</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
            <v-col lg="4">
              <v-row
                ><v-file-input
                  counter
                  @change="onFileSelected"
                  truncate-length="20"
                  label="Upload a new photo..."
                  v-model="inputFile"
                ></v-file-input
              ></v-row>
              <v-row>
                <v-btn :disabled="!inputFile" @click="submitFile()">
                  <v-icon left>mdi-arrow-up-bold-box</v-icon> Upload
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close()" color="#2B2118" dark> Retour</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CrudEspeceManagePhotos",
  data() {
    return {
      hasChanged: false,
      inputFile: null,
      dialogPhoto: true,
      isFileSelected: false,
      headers: [
        { text: "Image", align: "start", value: "image", sortable: false },
        { text: "Chemin Image", value: "chem_ima" },
        { text: "Actions", value: "actions", align: "right", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getImages",
      "getFamille",
      "getGenre",
      "getManagePhotoDetail",
      "getPollensAll",
      "getAdminActivePollenIndex",
    ]),
    activePollen() {
      return this.getPollensAll[this.getAdminActivePollenIndex];
    },
    getPollenFamille() {
      return this.getFamille.filter(
        (f) => f.id_famille === this.activePollen.id_famille
      )[0].nom_famille;
    },
    getPollenGenre() {
      return this.getGenre.filter(
        (f) => f.id_genre === this.activePollen.id_genre
      )[0].nom_genre;
    },
  },
  methods: {
    ...mapActions(["addImage", "deleteImage"]),
    /* requireImage(x) {
      return require("../assets/" + x);
    }, */
    /*     requireImage(x) {
      return require(x);
    }, */
    setOpenDetail(isOpen) {
      this.$store.commit("setManagePhotoDialog", isOpen);
    },
    
    
    close() {
      this.setOpenDetail(false);
      this.$nextTick(() => {
        this.$store.commit("setAdminActivePollenIndex", -1);
      });
    },
    onFileSelected() {
      console.log(this.inputFile);
    },
    submitFile() {
      const inputData = {
        chem_ima: this.inputFile,
        id_pollen: this.getPollensAll[this.getAdminActivePollenIndex].id_pollen,
      };
      console.log(inputData);
      this.addImage(inputData);
    },
    deleteItem(item) {
      this.deleteImage(item.id);
    },
  },
};
</script>

<style>
</style>